// extracted by mini-css-extract-plugin
module.exports = {"descriptionBox":"ProductDescription_descriptionBox__90c31","description":"ProductDescription_description__4e5b7"};